
export class MtmaTask {
	Id:             string;
	DeviceId:       number;
	Keycode:        string;
	Status:         string;
	ErrorCode:      number;
	ErrorMsg:       string;
	CurrentSubtask: number;
	//Subtasks:       []SubtaskInfo;
	Progress:       number;
	CreatedAt:      Date;
	UpdatedAt:      Date;
	FinishedAt:     Date;

    constructor() {
        this.Id = '';
    }
}
